import React from 'react';
import { useSelector } from 'react-redux';
import FeeItem from '../../../../components/FeeItem/FeeItem';
import Icon, { Icons } from '../../../../components/Icon/Icon';

import { t } from '../../../../lang';
import { createRootModal } from '../../RootModal';
import './ChangeFeePaymentMethod.scss';

const CHECKED_ICON_SIZE = 20;
const CREDIT_CURRENCY_ID = 8;

const ChangeFeePaymentMethod = createRootModal(({ handleClose }) => {
	const feeData = useSelector(store => store.send.feeData);
	const { methods, selectMethod } = useSelector(state => state.app.modals).find(
		modal => modal.tag === 'ChangeFeePaymentMethod'
	).outsideParams;

	const onSelect = account => {
		selectMethod(account);
		handleClose();
	};

	const getCheckedSignBox = method => (
		<div className='ChangeFeePaymentMethod__checked-sign-box'>
			{feeData.CurrencyId === method.CurrencyId && (
				<Icon
					className='ChangeFeePaymentMethod__checked-icon'
					type={Icons.CHECKMARK}
					width={CHECKED_ICON_SIZE}
					height={CHECKED_ICON_SIZE}
				/>
			)}
		</div>
	);

	return (
		<div className='ChangeFeePaymentMethod'>
			<div className='ChangeFeePaymentMethod__currencies'>
				{methods.map((method, index) => (
					<div key={index} className='ChangeFeePaymentMethod__FeeItem'>
						<FeeItem
							feeData={method}
							onClick={() => onSelect(method)}
							lowBalanceText={'Insufficient balance for this method.'}
							trailing={[getCheckedSignBox(method)]}
						/>
						{method.CurrencyId === CREDIT_CURRENCY_ID && (
							<div className='ChangeFeePaymentMethod__best-price'>
								<span>{t('Best price')}</span>
								<span>{t('Benefit up to')} 50%</span>
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
});

export default ChangeFeePaymentMethod;
